import {
  getFromLocalStorage,
  setLocalStorageWithExpiry,
} from "../utils/local-storage"

type RibbonProps = {
  name: string
  dismissalSeconds?: number
  closeButtonSelector?: string
  localStorage?: boolean
}

export default function ribbon(el: HTMLElement, props: RibbonProps) {
  const storageKey = "ribbon" + props.name
  const dismissalSeconds = props.dismissalSeconds || 86400
  const closeButtonSelector = props.closeButtonSelector || ".close--button"
  const closeButtonElement = el.querySelector(closeButtonSelector)
  //  This can be either local o session storage
  const useLocalStorage = props.localStorage || false

  // Listen to close ribbon to set local storage expiration - 1 week
  closeButtonElement?.addEventListener("click", () => {
    if (useLocalStorage) {
      setLocalStorageWithExpiry(storageKey, true, dismissalSeconds)
      el.classList.add("hidden")
    } else {
      sessionStorage.setItem(storageKey, "true")
      el.classList.add("hidden")
    }
  })

  // Display ribbon if informaition not in local storage
  if (useLocalStorage) {
    const ribbonDismissed = getFromLocalStorage(storageKey)
    if (!ribbonDismissed) {
      el.classList.remove("hidden")
    }
  } else {
    const sessionStorgeRibbon = sessionStorage.getItem(storageKey)
    if (!sessionStorgeRibbon) {
      el.classList.remove("hidden")
    }
  }
}
